import { Route, Routes } from "react-router-dom";
import { Routes as IntegrationRoutes } from "./routes";
import { IntegrationRouterCmp } from "./types";
import { IntegrationSearchPage } from "../pages/IntegrationSearchPage";
import { IntegrationSettingsPage } from "../pages/IntegrationSettingsPage";

const IntegrationRouter: IntegrationRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={IntegrationSearchPage.route} element={<IntegrationSearchPage />} />
        <Route path={IntegrationSettingsPage.route} element={<IntegrationSettingsPage />} />
      </Routes>
    </>
  );
};

IntegrationRouter.route = IntegrationRoutes.IntegrationRouter;

export default IntegrationRouter;
